import ToolGroup from '~/components/toolbar/shared/ToolGroup';
import BoxZoomTool from '~/components/toolbar/tools/BoxZoomTool';
import WindowingHistogramTool from '~/components/toolbar/tools/WindowingHistogramTool';
import SeriesOverviewTool from '~/components/toolbar/tools/SeriesOverviewTool';
import IntensityTool from '~/components/toolbar/tools/IntensityTool';
import MeasurementTool from '~/components/toolbar/tools/MeasurementTool';
import PanTool from '~/components/toolbar/tools/PanTool';
import ResetViewTool from '~/components/toolbar/tools/ResetViewTool';
import RotateViewTool from '~/components/toolbar/tools/RotateViewTool';
import ScreenshotTool from '~/components/toolbar/tools/ScreenshotTool';

export default function DefaultTools() {
    return (
        <ToolGroup>
            <PanTool />
            <BoxZoomTool />
            <RotateViewTool />
            <ResetViewTool />
            <WindowingHistogramTool />
            <SeriesOverviewTool />
            <MeasurementTool />
            <IntensityTool />
            <ScreenshotTool />
        </ToolGroup>
    );
}
